export const OFFRE_REDUCER_NAME = 'offre';
export const AUTOCOMPLETE_KEY = 'autocomplete';

export const specificsArticleLabels = {
    section: 'section-title',
    lineBreak: 'line-break',
};

export const specificsArticleLibelles = {
    section: 'Libellé',
    lineBreak: 'Saut de ligne',
};

export const OFFER_ACTIONS_SLICE_NAME = 'actions';
export const OFFER_ADDITIONAL_FIELDS_SLICE_NAME = 'offer_additional_fields';
export const REDUX_LIB_ARTICLE = 'articleSpecifics';
export const ARTICLES_SLICE_NAME = 'articles';
export const ARTICLES_CATEGORIES_SLICE_NAME = 'articles-categories';
export const CATALOGS_SLICE_NAME = 'catalogs';
export const CATALOGS_GRILLE_TARIFAIRE_SLICE_NAME = 'catalogs-grille-tarifaire';
export const CATALOGS_FULL_SLICE_NAME = 'catalogs-full';
export const DOCUMENT_SLICE_NAME = 'documents';
export const DOMAINS_SLICE_NAME = 'domains';
export const INVOICING_CATEGORIES_SLICE_NAME = 'invoicingCategories';
export const OFFER_CACHED_KEY = 'cached';
export const OFFER_GROUP_SLICE_NAME = 'offer_group';
export const OFFER_OPTIONS_SLICE_NAME = 'offer_options';
export const OFFER_OPTION_VALUES_SLICE_NAME = 'offer_option_values';
export const OFFERS_SLICE_NAME = 'offers';
export const PACKAGES_SLICE_NAME = 'packages';
export const OFFER_FORMALITES_SLICE_NAME = 'formalites';
export const PRESCRIPTEUR_ARTICLE_SLICE_NAME = 'prescripteur_article';
export const VATS_SLICE_NAME = 'vats';
export const REGLEDECALCULS_SLICE_NAME = 'regledecalculs';
export const ORIGINE_SLICE_NAME = 'origines';
